import { sdk, DEFAULT_COUNTRY, REGION_ID } from '@/lib/medusa';

let cache = null;

async function listRegions() {
  if (cache) return cache;
  const { regions } = await sdk.client.fetch('/store/regions', {
    method: 'GET',
    next: { tags: ['regions'], revalidate: 3600 },
  });
  cache = regions || [];
  return cache;
}

export async function getRegion(countryCode = DEFAULT_COUNTRY) {
  try {
    const regions = await listRegions();
    if (!regions.length) return null;
    if (REGION_ID) {
      const byId = regions.find((r) => r.id === REGION_ID);
      if (byId) return byId;
    }
    const cc = (countryCode || '').toLowerCase();
    return (
      regions.find((r) => r.countries?.some((c) => c?.iso_2 === cc)) ||
      regions[0]
    );
  } catch (e) {
    console.error('[regions] failed:', e);
    return null;
  }
}

/**
 * Return the ISO-3166 alpha-2 codes of every country the shop ships to. These
 * are the countries attached to the active Medusa region, so the checkout
 * country selector only ever offers destinations the backend actually serves
 * (a cart address outside the region is rejected with `invalid_data`).
 */
export async function getServedCountries(countryCode = DEFAULT_COUNTRY) {
  try {
    const region = await getRegion(countryCode);
    if (!region) return [];
    const codes = (region.countries || [])
      .map((c) => c?.iso_2)
      .filter(Boolean)
      .map((c) => c.toLowerCase());
    return Array.from(new Set(codes)).sort();
  } catch (e) {
    console.error('[regions] served countries failed:', e);
    return [];
  }
}
